import gql from 'graphql-tag';

export const GET_MATERIALS_REQUESTS = gql`
  query GET_MATERIALS_REQUESTS($limit: Int = 10, $offset: Int = 0, $workflowStep: String = null, $id: Int = null, $name: String = null, $erpCode: String = null, $organizationDivisionsIDs: [Int!]!) {
    count: mdm_collahuasi_material_creation_aggregate(where: {workflow_step: {name: {_eq: $workflowStep}}, id: {_eq: $id}, name: {_ilike: $name}, erpCode: {_eq: $erpCode}, organizationDivisionId: {_in: $organizationDivisionsIDs}}) {
      aggregate {
        totalRows: count
      }
    }
    listOfRequest: mdm_collahuasi_material_creation(limit: $limit, offset: $offset, where: {workflow_step: {name: {_eq: $workflowStep}}, id: {_eq: $id}, name: {_ilike: $name}, erpCode: {_eq: $erpCode}, organizationDivisionId: {_in: $organizationDivisionsIDs}}, order_by: {createdAt: desc}) {
      id
      createdAt
      name
      user {
        first_name
        user_name
      }
      workflow_step {
        name
        id
      }
      updatedAt
      erpCode
      isIntegrated
      lastAction
      organizationDivisionId
    }
  }
`;

export const GET_SIMILAR_MATERIALS = gql`
query GET_SIMILAR_MATERIALS($searchID: uuid!) {
  item_match(where: {search_id: {_eq: $searchID}}, order_by: {match: desc}) {
    match
    item {
      erp_code
      description
      price
      updated_at
      manufacturer_partnumber
      currency
      id
      mdm_name
      catalog {
        organization {
          name
          country
        }
      }
      name
    }
  }
}
`;

export const GET_MATERIALS_REQUESTS_BY_ID = gql`
query GET_MATERIALS_REQUESTS_BY_ID($id: Int!) {
  materialrequestById: mdm_collahuasi_material_creation_by_pk(id: $id) {
    analystNameId
    annualConsumptionId
    attachedFiles
    availibilityId
    categoryId
    erpCode
    clase
    classGroupId
    colloquial1
    colloquial2
    colloquial3
    colloquial4
    colloquial5
    componentCodeId1
    componentCodeId2
    componentCodeId3
    componentCodeId4
    createdAt
    creationDate
    creationUser
    criticality
    criticalitySOSId
    dateSOS
    enabledManufacturer2
    equipmentReferenceId1
    equipmentReferenceId2
    equipmentReferenceId3
    equipmentReferenceId4
    equipmentTypeId1
    equipmentTypeId2
    equipmentTypeId3
    equipmentTypeId4
    estimatedPrice
    expenseItemId
    extendDescription
    familia
    hazardIndexId
    id
    installedQuantity1
    installedQuantity2
    installedQuantity3
    installedQuantity4
    isActive
    isIntegrated
    itemNameCodeId
    manufacturerAbbreviation1
    manufacturerAbbreviation2
    manufacturerId1
    manufacturerId2
    manufacturerPre1
    manufacturerPre2
    name
    operationalAreaId1
    operationalAreaId2
    operationalAreaId3
    operationalAreaId4
    partNumber1
    partNumber2
    preEquipmentReference1
    preEquipmentReference2
    preEquipmentReference3
    preEquipmentReference4
    preference1
    preference2
    purchasing
    qualifierStockId
    qualifierStockId2
    reemplazaCodigoEllipse
    referenceGroup1
    referenceGroup2
    referenceGroup3
    referenceGroup4
    reorderPoint
    reorderQuantity
    requestTypeId
    responsibleAreaId
    segmento
    shortDescription
    stockMaxSOS
    stockMin
    stockMinSOS
    stockTypeId
    unitId
    updatedAt
    urgency
    warehouseId
    workflowId
    workflowStepId
    userResponsibleSOS
    workflow_step {
      stepApproval
      stepReject
      name
    }
    searchStatistics
    searchStatisticProvider
    partNumberRf1
    partNumberRf2
    organizationDivisionId
  }
  logs: mdm_workflow_step_log(where: {materialCreationId: {_eq: $id}}, order_by: {id: asc}) {
    actionDate
    actualStep
    beforeStep
    comment
    endAction
    id
    user {
      user_name
    }
    workflow_action {
      id
      description
    }
  }
}
`;

export const GET_WORKFLOW_STEPS = gql`
  query GET_WORKFLOW_STEPS($workflowId: Int!) {
    workflow_steps: mdm_workflow_step(order_by: {stepOrder: asc}, where: {workflowId: {_eq: $workflowId}}) {
      id
      name
      stepApproval
      stepReject
      stepOrder
    }
  }
`;

// This is where General information dropdowns are fetched
export const GET_ITEM_NAME_CODE_DROPDOWN = gql`
  query GET_ITEM_NAME_CODE_DROPDOWN {
    item_name_code_list: mdm_collahuasi_types( where: { combo_objeto: { _eq: "CollahuasiItemNameCode" } }) {
      id
      code
      description
    }
  }
`;

export const GET_PRODUCT_SERVICE_CATEGORY_DROPDOWN = gql`
query GET_PRODUCT_SERVICE_CATEGORY_DROPDOWN($keyWords: String = null, $offset: Int = 0, $limit: Int = 50) {
  list_product_category: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiClassGroup"}, name: {_ilike: $keyWords}}, limit: $limit, offset: $offset) {
    id
    code
    name
  }
  count: mdm_collahuasi_types_aggregate(where: {combo_objeto: {_eq: "CollahuasiClassGroup"}}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_PRODUCT_SERVICE_CATEGORY_BY_ID = gql`
query GET_PRODUCT_SERVICE_CATEGORY($limit: Int = 1, $id: Int = 1234567892) {
  getByID: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiClassGroup"}, id: {_eq: $id}}, limit: $limit) {
    id
    code
    name
  }
}
`;

export const GET_UOM = gql`
  query GET_UOM {
    uom: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiUnit"}}) {
      id
      code
      description
    }
  }
`;

export const GET_MANUFACTURER_DROPDOWN = gql`
  query GET_MANUFACTURER_DROPDOWN(
    $_similar: String = ""
    $id: Int = null
  ) {
    manufacturer_list: mdm_collahuasi_types(
      where: {
        combo_objeto: { _eq: "CollahuasiManufacturer" }
        description: { _similar: $_similar }
        id: { _eq: $id }
      }
    ) {
      id
      code
      description
    }
  }
`;

export const GET_SEGMENT_FAMILY_CLASS = gql`
  query GET_SEGMENT_FAMILY_CLASS(
    $parent_taxonomy: String = ""
    $id : Int = null
  ) {
    segmentFamilyClassList: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiTaxonomy"}, parent_taxonomy_id: {_eq: $parent_taxonomy}, id: {_eq: $id}}) {
      id
      code
      name
      parent_taxonomy_id
      taxonomy_id
      is_active
    }
  }
`;
// This is where General information ends

// inventory tab begings here

export const GET_CATEGORY = gql`
  query GET_CATEGORY {
    category: mdm_collahuasi_types(
      where: { combo_objeto: { _eq: "CollahuasiCategory" } }
    ) {
      id
      code
      description
    }
  }
`;

export const GET_CATEGORY_DEFAULT = gql`
  query GET_CATEGORY_DEFAULT {
    category: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiCategory"}, description: {_eq: "A PEDIDO (R Usuario) - R"}}) {
      id
    }
  }
`;

export const GET_STOCK_TYPE = gql`
  query GET_STOCK_TYPE {
    stock_type: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiStockType"}}) {
      id
      code
      description
    }
  }
`;

export const GET_CRITICALLITY_SOS = gql`
  query GET_CRITICALLITY_SOS {
    criticallity_sos: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiCriticalitySOS"}}, order_by: {id: asc}) {
      id
      code
      description
    }
  }
`;

export const GET_AVAILABILITY = gql`
  query GET_AVAILABILITY {
    availability : mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiAvailibility"}}, order_by: {code: asc}) {
      id
      code
      description
    }
  }
`;

export const GET_ANUAL_CONSUMPTION = gql`
  query GET_ANUAL_CONSUMPTION {
    anual_consumption : mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiAnnualConsumption"}}, order_by: {code: asc}) {
      id
      code
      description
    }
  }
`;

export const GET_EXPENSE_ITEM = gql`
  query GET_EXPENSE_ITEM {
    expense_item : mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiExpenseItem"}}) {
      id
      code
      description
      is_active
    }
  }
`;

export const GET_HAZARD_INDEX = gql`
  query GET_HAZARD_INDEX {
    hazard_index : mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiHazardIndex"}}) {
      id
      code
      description
    }
  }
`;

export const GET_RESPONSIBLE_AREA = gql`
  query GET_RESPONSIBLE_AREA {
    responsible_area : mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiResponsibleArea"}}) {
      id
      code
      description
    }
  }
`;

export const GET_WAREHOUSE = gql`
  query GET_WAREHOUSE {
    warehouse : mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiWarehouse"}}) {
      id
      code
      description
    }
  }
`;

export const GET_STOCK_QUALIFIERS = gql`
  query GET_STOCK_QUALIFIERS {
    stockQualifiers : mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiQualifierStock"}}) {
      id
      code
      description
    }
  }
`;

// inventory tab ends here

// Equipment APL starts here
export const GET_OPERATIONAL_AREA = gql`
  query GET_OPERATIONAL_AREA {
    operational_area: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiEquipmentGroup"}}) {
      id
      code
      name
    }
  }
`;

export const GROUP_TYPE = gql`
  query GROUP_TYPE {
    group_type: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiEquipmentType"}}) {
      id
      code
      description
    }
  }
`;

export const GET_GROUP_REFERENCE = gql`
  query GET_GROUP_REFERENCE {
    group_reference: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiReferenceGroup"}}) {
      id
      code
      description
      area
    }
  }
`;

export const GET_EQUIPMENT_REFERENCE = gql`
  query GET_EQUIPMENT_REFERENCE {
    equipment_reference: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiEquipmentReference"}}) {
      id
      code
      description
      area
    }
  }
`;

export const GET_COMPONENT_CODE = gql`
  query GET_COMPONENT_CODE {
    component_code: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiComponentCode"}}) {
      id
      code
      description
    }
  }
`;

export const GET_MDM_WORKFLOW_USER = gql`
query GET_MDM_WORKFLOW_USER($userUUID: uuid!) {
  mdm_workflow_user(where: {user: {id: {_eq: $userUUID}}}) {
    canApprove
    canCancel
    canReject
    canSave
    organizationDivisionId
    organization_division {
      centerCode
      id
      isEnabled
      name
      organizationId
      parentCode
      parentCodeId
      parentName
    }
    workflowId
    workflowStepId
    userId
  }
}
`;

export const GET_MDM_WORKFLOW_STEP_ATTRIBUTE = gql`
query GET_MDM_WORKFLOW_STEP_ATTRIBUTE($workflowStepId: Int!, $workflowID: Int!) {
  attributeMeta: mdm_workflow_step_attribute(where: {workflowStepId: {_eq: $workflowStepId}, workflow_step: {workflowId: {_eq: $workflowID}}}, order_by: {titulo: asc, vista: asc}) {
    readOnly
    workflowAttributeId
    mostrar
    titulo
    workflow_attribute {
      nombreBaseDato
    }
    vista
  }
}
`;

export const GET_ANALYSTS_NAMES = gql`
query GET_ANALYSTS_NAMES {
  analysts_names: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiAnalystName"}, is_active: {_eq: true}}) {
    id
    code
    description
  }
}
`;

export const GET_PURCHASING_OFFICERS = gql`
query GET_PURCHASING_OFFICERS {
  purchasing_officers: mdm_collahuasi_types(where: {combo_objeto: {_eq: "CollahuasiPurchasing"}, is_active: {_eq: true}}) {
    id
    code
    description
  }
}
`;

export const GET_WORKFLOW_ID = gql`
query GET_WORKFLOW_ID($tax_id: String!) {
  mdm_workflow(where: {organization: {tax_id: {_eq: $tax_id}}}) {
    id
  }
}
`;

export const GET_WORKFLOW_ACTIONS = gql`
query GET_WORKFLOW_ACTIONS($workflowID: Int!) {
  mdm_workflow_action(where: {workflowId: {_eq: $workflowID}}, order_by: {id: asc}) {
    description
    id
  }
}
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/catalogerUser.js